import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const ApprovalStatus = ({ approvalStatus, setApprovalStatus, dataList }) => {
  const isAll = approvalStatus?.includes(-1)
  const [checked, setChecked] = useState(isAll)
  const [disabled, setDisabled] = useState(isAll)

  const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked)

  useEffect(() => {
    if (refreshClicked) {
      setChecked(isAll)
      setDisabled(isAll)
    }
  }, [refreshClicked])

  const handleCheckChange = (event) => {
    const isChecked = event.target.checked
    setChecked(isChecked)
    setDisabled(isChecked)
    if (isChecked) {
      setApprovalStatus([-1])
    } else {
      setApprovalStatus([])
    }
  }

  const handleChange = (event) => {
    const selectedStatus = event.target.value
    setApprovalStatus(selectedStatus)
    setChecked(selectedStatus.includes(-1))
  }

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={9}>
          <FormControl fullWidth size="small">
            <InputLabel>Approval Status</InputLabel>
            <Select
              multiple
              disabled={disabled}
              value={approvalStatus || []}
              onChange={handleChange}
              input={<OutlinedInput label="Approval Status" />}
              MenuProps={MenuProps}
              sx={
                disabled && {
                  backgroundColor: 'hsl(0, 0%, 95%)',
                }
              }
              renderValue={(selected) => {
                if (selected.includes(-1)) {
                  return 'All'
                }
                return selected
                  .map((x) => dataList.find((y) => y.approvalStatusId === x)?.approvalStatusName)
                  .join(', ')
              }}
            >
              {dataList.map((item) => (
                <MenuItem key={item.approvalStatusId} value={item.approvalStatusId}>
                  <Checkbox checked={approvalStatus?.includes(item.approvalStatusId)} />
                  <ListItemText primary={item.approvalStatusName} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormGroup>
            <FormControlLabel control={<Checkbox checked={checked} onChange={handleCheckChange} />} label="All" />
          </FormGroup>
        </Grid>
      </Grid>
    </>
  )
}

export default ApprovalStatus